function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomShowerToiletFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 7.3c0-1.218-.353-2.03-.818-2.528C24.72 4.277 24.063 4 23.267 4c-.853 0-1.603.453-1.99 1.214 1.685.543 2.68 2.04 2.985 3.556.067.336.101.672.101 1v1H15v-1c0-.331.04-.667.117-1 .411-1.774 1.887-3.446 4.086-3.728C19.745 3.247 21.324 2 23.267 2c1.282 0 2.492.46 3.377 1.407C27.526 4.353 28 5.691 28 7.3v20.672h2v2h-2V30h-2v-.028H13.94V30H5.27v-.028H2v-2h3.27v-1.886a4.736 4.736 0 01-1.238-2.666H4v-9h4.917v7h8.218v1.455c0 2.087-1.372 3.715-3.195 4.36v.737H26V7.3zM19.863 7c-1.308 0-2.259.811-2.657 1.77h4.99a2.996 2.996 0 00-.508-.94c-.396-.485-.966-.83-1.825-.83zM7.27 27.972h4.67v-2.34l.824-.147c1.205-.216 2.082-1.033 2.312-2.065h-9.02c.119.566.42 1.091.88 1.502l.334.298v2.752zm-.353-6.552v-5H6v5h.917z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.363 15h-2v-3h2v3zM17 15h-2v-3h2v3zM20.682 15v-3h-2v3h2zM17 20.42h-7v-2h7v2z",
    fill: props.color
  }));
}

export default SvgIconRoomShowerToiletFilled;